import React, { useState } from 'react';

import './KafkaLogger.scss';

import { LoadingIndicator } from '@spark-labs/avocado-ui/dist/components/LoadingIndicator';
import { InlineIcon } from '@spark-labs/avocado-ui';

// tslint:disable-next-line:max-line-length
import { KafkaLoggerHeader } from '@go-client/components/KafkaControl/KafkaLogger/KafkaLoggerHeader/KafkaLoggerHeader';

import { KafkaLogs } from '@go-client/components/KafkaControl/KafkaLogger/KafkaLogs';
import { getFilteredKafkaLogs } from '@go-client/lib/api/kafkaLogger';
import { KafkaLoggerFilters, KafkaMessage } from '@go-shared/types/kafkaLogs';
import { RouteComponentProps } from 'react-router';

// tslint:disable-next-line
interface KafkaLoggerProps extends RouteComponentProps {}
const KafkaLogger: React.FC<KafkaLoggerProps> = () => {
  const [retrievedLogs, setRetrievedLogs] = useState<KafkaMessage[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [noSearchYet, setNoSearchYet] = useState(true);
  const getKafkaLogs = async (filters: KafkaLoggerFilters) => {
    try {
      setNoSearchYet(false);
      const { logs } = await getFilteredKafkaLogs(filters);
      setRetrievedLogs(logs);
    } catch (e) {
      setRetrievedLogs([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOnSearch = async (filters: KafkaLoggerFilters) => {
    await getKafkaLogs(filters);
  };
  return (
    <main className="w-full h-full">
      <div className="align-with-logo items-baseline">
        <KafkaLoggerHeader onSearch={handleOnSearch} />
      </div>
      {isLoading ? (
        <div className="content-minus-logo items-center flex justify-center w-full">
          <LoadingIndicator />
        </div>
      ) : retrievedLogs.length !== 0 ? (
        <KafkaLogs logs={retrievedLogs} />
      ) : (
        <EmptyLogs noSearch={noSearchYet} />
      )}
    </main>
  );
};

const EmptyLogs: React.FC<{ noSearch: boolean }> = ({ noSearch }) => {
  return (
    <div className="content-minus-logo empty-records justify-center items-center flex">
      <div className="message-wrapper">
        <span className="empty-icon flex justify-center">
          <InlineIcon name="bell" className="text-blue-light text-center" />
        </span>
        <h2 className="text-center text-blue-light mt-6 mb-8 font-normal">
          {!noSearch
            ? 'There are no logs available for your search'
            : 'Trigger a search entering a voyage ID'}
        </h2>
      </div>
    </div>
  );
};
export default KafkaLogger;
